import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { DashboardCard } from './dashboard.model';
import { SparklineComponent } from './sparkline.component';

@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [RouterLink, MatIconModule, SparklineComponent],
  template: `
    @let c = card();
    <a class="card" [routerLink]="c.link">
      <div class="card-head">
        <mat-icon class="material-symbols-outlined icon">{{ c.icon }}</mat-icon>
        <span class="title">{{ c.title }}</span>
        @if (c.chip) {
          <span class="chip" [class]="c.chip.tone">{{ c.chip.text }}</span>
        }
      </div>
      <div class="figure">{{ c.figure }}@if (c.figureNote) {<small>{{ c.figureNote }}</small>}</div>
      @if (c.series?.length) {
        <app-sparkline [values]="c.series!" [label]="c.title + ' dos últimos meses'"></app-sparkline>
      }
      <ul class="facts">
        @for (line of c.facts; track $index) {
          <li>@for (part of line; track $index) {@if (part.strong) {<b>{{ part.text }}</b>} @else {<span>{{ part.text }}</span>}}</li>
        }
      </ul>
      <span class="open">{{ c.linkLabel }}<mat-icon>chevron_right</mat-icon></span>
    </a>
  `,
  styles: [`
    :host { display: block; }
    .card {
      height: 100%;
      box-sizing: border-box;
      background: var(--app-surface);
      border: 1px solid var(--app-border);
      border-radius: 10px;
      padding: 12px 14px;
      display: grid;
      grid-template-rows: auto auto auto 1fr auto;
      gap: 6px;
      color: var(--app-text);
      text-decoration: none;
    }
    .card:hover { border-color: var(--app-accent); }
    .card:focus-visible { outline: 2px solid var(--app-accent); outline-offset: 2px; }
    .card-head { display: flex; align-items: center; gap: 8px; }
    .icon {
      width: 30px; height: 30px; border-radius: 8px; display: grid; place-items: center; font-size: 18px;
      background: var(--app-accent-container); color: var(--app-on-accent-container);
    }
    .title { font-weight: 500; font-size: 15px; }
    .chip {
      margin-left: auto; font-size: 11px; font-weight: 500; padding: 2px 8px; border-radius: 10px; white-space: nowrap;
      background: var(--app-chip-bg); color: var(--app-chip-text);
    }
    .chip.warn { background: var(--app-warning-bg); color: var(--app-warning); }
    .chip.ok { background: var(--app-success-bg); color: var(--app-success); }
    .figure { font-size: 20px; font-weight: 500; font-variant-numeric: tabular-nums; }
    .figure small { font-size: 12px; font-weight: 400; color: var(--app-muted); margin-left: 6px; }
    .facts { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 3px; font-size: 12.5px; color: var(--app-muted); }
    .facts b { color: var(--app-text); font-weight: 500; }
    .open { font-size: 12.5px; font-weight: 500; color: var(--app-accent); display: inline-flex; align-items: center; }
    .open mat-icon { font-size: 16px; width: 16px; height: 16px; }
  `]
})
export class DashboardCardComponent {
  card = input.required<DashboardCard>();
}
